import styled from 'styled-components';

import { basic } from 'quarks/interpolations/basic';

const Container = styled.div`
  ${basic}
`;

export default Container;
